module.exports = {
  messages: {
    BUTTON_BACK: 'Zurück',
    COMMUNICATION_ERROR_500_SUBLINE:
      'Aber sie sollten gleich frisch und munter zurück sein. Sorry und danke für ein wenig Geduld.',
    COMMUNICATION_ERROR_500_TITLE:
      'Unsere Server machen wohl gerade ’ne Kaffee-Pause.',
    JOBS_FIND_JOBS_SEARCH_BUTTON: 'Jobs finden',
    LOSP_SWIMP_COMPANY_LABEL: 'Bei welcher Firma und/oder in welcher Stadt?',
    LOSP_SWIMP_COMPANY_PLACEHOLDER: 'z. B. REWE GROUP in Köln',
    LOSP_SWIMP_CONTINUE_BUTTON: 'Weiter',
    LOSP_SWIMP_ERROR_BUTTON_PROMPT: 'Zurück',
    LOSP_SWIMP_ERROR_BUTTON_SYSTEM: 'Wiederholen',
    LOSP_SWIMP_ERROR_TEXT_PROMPT:
      'Gib zumindest Deinen Job-Titel und Deinen Arbeitgeber ein. Gern auch Deinen Arbeitsort.',
    LOSP_SWIMP_ERROR_TITLE_PROMPT: 'Ohne echten Input wird’s schwer',
    LOSP_SWIMP_LOADING_SUBTITLE:
      'und beginnt mit der Suche nach passenden Jobs für Dich.',
    LOSP_SWIMP_LOADING_TITLE: 'Die XING KI erstellt Dein Profil ...',
    LOSP_SWIMP_ROLE_LABEL: 'Was machst Du aktuell beruflich?',
    LOSP_SWIMP_ROLE_PLACEHOLDER:
      'z. B. Ich bin Produkt Managerin und Excel-Profi',
    LOSP_SWIMP_SUBTITLE: 'Erstell jetzt Dein Jobsuche-Profil mit der XING KI.',
    LOSP_SWIMP_TITLE_B: 'Klick … klick …',
    LOSP_SWIMP_TITLE_C: 'Quick Match',
  },
};
